<template>
  <a-spin :spinning="spinning">
    <div class="modal-header">
      <div class="modal-title">
        <span>({{ data.name }})采集结果</span>
      </div>
    </div>
    <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" :form="form">
      <a-row :gutter="24">
        <a-col :span="24" v-for="(item, index) in data.results" :key="index">
          <a-form-item
            :label="item.value.label"
            has-feedback
            v-if="!item.value.isFile"
          >
            <a-input readonly :value="item.value.value" :disabled="false" />
          </a-form-item>
          <a-form-item :label="item.value.label" has-feedback v-else>
            <div v-for="(it, i) in item.value.value" :key="i">
              <a class="_link"
                target="_blank" 
                @click="preview(it)"
              >
                <a-icon :type="it.fileType  ? 'picture' : 'file'" />
                <span style="margin-left: 5px;">{{it.oUrl}}</span>
              </a>
            <a class="_link"
                target="_blank" 
                @click="watermark_preview(it)"
                  v-if="it.isWaterMark"
              >
                <a-icon :type="it.watermark_fileType ? 'picture' : 'file'" />
                <span style="margin-left: 5px;">{{it.watermark_oUrl}}</span>
              </a>
            </div>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <img alt="example" style="width: 100%;margin-top:30px;" :src="previewImage" />
    </a-modal>
  </a-spin>
</template>
<script>
import { ModalComponentBase } from "@/shared/component-base";
import { AppConsts } from "@/abpPro/AppConsts";
import { environment } from "@/environments/environment";
import { CommonServiceProxy } from "@/shared/common-service";
export default {
  mixins: [ModalComponentBase],
  name: "collection-form-result",
  data() {
    return {
      // 获取到的数据
      entity: {},
      spinning: false,
      _serviceProxy: "",
      labelCol: {
        span: 5,
      },
      // 上传文件
      fileList: [],
      uploadUrl: "",
      subdirName: "",
      isDisabled: false,
      commonService: null,
      data: {},
      previewVisible: false,
      previewImage: "",
    };
  },
  components: {},
  beforeCreate() {
    this.form = this.$form.createForm(this, {
      name: "register",
    });
  },
  created() {
    this.commonService = new CommonServiceProxy(this.$apiUrl, this.$api);
    this.fullData(); // 模态框必须,填充数据到data字段
    this.uploadUrl = AppConsts.uploadBaseUrl + "/API/Upload";
    this.subdirName = environment.production ? "abpProd" : "abpDev";
  },
  async mounted() {
    if (this.recordId && this.collectionFormId) {
      await this.getData();
    }else{
      await this.getData();
    }
  },
  methods: {
    /**
     * 获取数据
     */
    async getData() {
      let _that = this;
      _that.spinning = true;
      try {
        let res = await _that.commonService.post({
          url: "/api/services/app/PersonnelTask/OpenCollectionResult",
          params: {
            recordId: _that.recordId,
            collectionFormId:_that.collectionFormId
          },
        });
        // let arr = [];
        if (res.results != null && res.results.length > 0) {
          res.results.forEach((item) => {
            // 重写处理图片
            if (item.value.value && item.value.value.indexOf('/static/') !== -1) {
              let _value = item.value.value
              let imgArr = [];
              // console.log(_value);
              if (_value.indexOf(',') !== -1) {
                let _arr = _value.split(',');
                // imgArr = 
                _arr.forEach(it => {
                  // console.log(it);
                  if(it.indexOf("|")!==-1){
                    let img_arr = it.split('|');
                    imgArr.push({
                      isWaterMark:true,
                      oUrl: "[原图]",
                      url: `${AppConsts.uploadBaseUrl}${img_arr[0]}`,
                      fileType: this.isImage(img_arr[0].split('.')[1]) ? 'img' : 'otherFile',
                      watermark_oUrl:"[水印图]",watermark_url: `${AppConsts.uploadBaseUrl}${img_arr[1]}`, watermark_fileType: this.isImage(img_arr[1].split('.')[1])
                    })
                  }else {
                    imgArr.push({
                      oUrl: "[原图]",
                      url: `${AppConsts.uploadBaseUrl}${it}`,
                      fileType: this.isImage(it.split('.')[1]) ? 'img' : 'otherFile',
                    })
                  }
                  // return {
                  //   oUrl: "[原图]",
                  //   url: `${AppConsts.uploadBaseUrl}${it}`,
                  //   fileType: this.isImage(it.split('.')[1]) ? 'img' : 'otherFile',
                  // }
                })
              } else {
                if(_value.indexOf("|")!==-1){ //watermark
                let img_arr = _value.split('|');
                  imgArr = [{isWaterMark:true,oUrl:"[原图]",url: `${AppConsts.uploadBaseUrl}${img_arr[0]}`, fileType: this.isImage(img_arr[0].split('.')[1])? 'img' : 'otherFile',watermark_oUrl:"[水印图]",watermark_url: `${AppConsts.uploadBaseUrl}${img_arr[1]}`, watermark_fileType: this.isImage(img_arr[1].split('.')[1])? 'img' : 'otherFile'}]
                }else{
                  imgArr = [{oUrl:"[原图]",url: `${AppConsts.uploadBaseUrl}${_value}`, fileType: this.isImage(_value.split('.')[1])? 'img' : 'otherFile'}]
                }
              }
              console.log(imgArr);
              item.value.value = imgArr;
              item.value.isFile = true;
            } else if (item.value.value && (item.value.value.toLowerCase() === "true" || item.value.value.toLowerCase() === "false")) {
              item.value.value = item.value.value ? "是" : "否";
            }
          });
        }
        _that.data = res;
        _that.spinning = false;
      } catch (error) {
        console.error(error);
        _that.spinning = false;
      }
    },
    isImage(ext) {
      // ext=ext?ext:"";
      return ext?(
        [
          "png",
          "jpg",
          "jpeg",
          "bmp",
          "gif",
          "webp",
          "psd",
          "svg",
          "tiff",
        ].indexOf(ext.toLowerCase()) !== -1
      ):false;
    },
    // 关闭模态框
    handleCancel() {
        this.previewImage = "data:image/png;base64,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";
      this.previewVisible = false;
    },
    preview(item) {
      // console.log(item);
      if (item.fileType) {
        this.handlePreview(item.url);
      } else {
        window.open(item.url);
      }
    },
    watermark_preview(item) {
      if (item.watermark_fileType) {
        this.handlePreview(item.watermark_url);
      } else {
        window.open(item.watermark_url);
      }
    },
    // 打开模态框（图片预览）
    async handlePreview(file) {
      this.previewImage = file;
      this.previewVisible = true;
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.btn--container {
  display: block;
  margin: 10px auto;
  text-align: center;
}
._img {
  width: 100px;
  margin-left: 10px;
}
._img:first-of-type{
  margin-left: 0;
}
._link{
  margin-left: 10px;
}
</style>